var map = {
	"./diapositiva-4-1.png": "97ca",
	"./diapositiva-4-2.png": "8e85",
	"./diapositiva-4-3.png": "3103",
	"./diapositiva-4-4.png": "cf6d",
	"./diapositiva-4-5.png": "3b99"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2111";